import React, { useEffect, useState } from 'react'
import { HashRouter as Router, Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom'
import { Card, Button, Row, Col } from 'react-bootstrap'
//import notAuthImg from '../../../assets/img/pages/not-authorized.png'
import { useTranslation } from 'react-i18next';
import useAuth from 'hooks/useAuth';

const prefixPage = ''
const WelcomePage = ({ match }) => {
  const { isLoggedIn, user, config, perspective } = useAuth(); //
  const history = useHistory('hospital')
  const location = useLocation();
  const { t } = useTranslation();
  const [permitPerspective, setPermitPerspective] = useState([])
  const [redirectPath,setRedirectPath] = useState()
  useEffect(() => {
    //history.push('/hospital/hosp-dashboard')
    //console.log('welcome step')

    let userPermissions = user.permissions || []
    //Check Permission
    let defaultMenu = null
    const find = config.find(({ configCode }) => configCode === 'menu_visible')   
    
    console.log('per',location)
    setPermitPerspective(perspective.map((item, index) => {
      const routePath = item.redirectPath || null
      let allowPerspective = false
      let allowPath = false
      let allowDefaultPath = null
      let routePermissions =  [];
      if (routePath && find) {
          find.jsonData.permissions.forEach((permission) => {
            const per = permission?.perspective?.find((per)=>per.perspectiveId===item.perspectiveId)
            if(per){
              const routePerm = per.paths.some(path => routePath.startsWith(path));
              if (routePerm) {
                routePermissions.push(permission.role)   
              }
              if (!allowPerspective && per?.routePath) {
                allowPerspective = routePath.startsWith(per?.routePath)                
              }
              if(allowPerspective){
                allowDefaultPath = per.paths.length>1 ? per.paths[1] :null
              }
              if(permission?.defaultMenu ){
                defaultMenu = permission?.defaultMenu
              }
            }            
          })        
      }

      if(!(allowPerspective && (routePermissions.some(permission => userPermissions.includes(permission))))){
        item.redirectPath = allowDefaultPath || null
      }
      
      if(defaultMenu && location?.pathname===defaultMenu?.perspective?.routePath){
        const routePath = defaultMenu.perspective?.routePath || ''
        const menuPath = defaultMenu.menu.path || ''

        if (menuPath.startsWith(routePath)) {
          item.redirectPath = menuPath
        } else {
          item.redirectPath = routePath + menuPath
        }

        setRedirectPath(item.redirectPath)
      }

      return item;
    }))
  }, [perspective])

  //return (<div>Hello Man : {redirectPath}</div>)

  return (<Row className="m-0">

    <Col lg="12" md="12" sm="12">

    </Col>
    <Col sm="12">
      <Card className="auth-card bg-transparent shadow-none rounded-0 mb-0 w-100">

        {/* <img
              src={notAuthImg}
              alt="notAuthImg"
              className="img-fluid align-self-center mt-75"
            /> */}
        <h1 className="font-large-2 my-2">{t(`${prefixPage}Welcome CK-Doctor`)}</h1>
        <p className="pt-2 mb-0">
        </p>
        <p className="pb-2">
        </p>
        <Switch>
          {
            permitPerspective.map((item, index) => (
              <Route path={item?.routePath} exact key={index}>

                {item?.redirectPath ? (
                   <Redirect to={`${item?.redirectPath}${location.search}`} />                  
                ) : (
                  <div></div>
                )}
              </Route>
            ))
          }
        </Switch>
      </Card>
    </Col>
  </Row>
  )

}
export default WelcomePage
